import { render, staticRenderFns } from "./AcademicYearsSelectbox.vue?vue&type=template&id=626635d6&"
import script from "./AcademicYearsSelectbox.vue?vue&type=script&lang=js&"
export * from "./AcademicYearsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports